import React from "react";
import { FixedFooter } from "components";
import ViewBasket from "components/basket/ViewBasket";
import WithLoading from "components/Hoc/WithLoading";
import { useDineIn } from "modules/dine-in/hooks";
import { TranslationText } from "components/TextTranslationContainer";

const MenuContainer = (props) => {
  const { viewBasketPage } = useDineIn();
  return (
    <WithLoading>
      {props?.filteredMenu?.length === 0 ? (
        <div className="h-app-height p-4">
          {props?.searchTerm?.length > 0 && (
            <TranslationText className="text-center mt-4 font-semibold text-red-500" text="We didn’t find any results for" contentProps={{searchTerm: props?.searchTerm}}/>
          )}
        </div>
      ) : (
        props?.children
      )}
      {/* {!props?.hideFooter &&  <Footer />} */}
      {props?.hideFooter ? null : (
        <FixedFooter basketFooter={true} page={true} from="menu">
          <ViewBasket {...{ viewBasketPage }} />
        </FixedFooter>
      )}
    </WithLoading>
  );
};

export default MenuContainer;
